/**
 * Color tokens for scoring views — keyed by rubric level.
 * Source: PRD §5.3 + brand palette in marketing /assets/style.css.
 */
export const RUBRIC_COLORS = {
  Strong: { bg: "#D1FAE5", fg: "#065F46", solid: "#059669" },
  Developing: { bg: "#DBEAFE", fg: "#1E40AF", solid: "#2563EB" },
  Emerging: { bg: "#FED7AA", fg: "#9A3412", solid: "#D97706" },
  "At Risk": { bg: "#FEE2E2", fg: "#991B1B", solid: "#DC2626" },
};

export function rubricColor(level) {
  return RUBRIC_COLORS[level] || { bg: "#F5F5F5", fg: "#555555", solid: "#6F6F6F" };
}

export function dimensionLabel(key) {
  return (
    {
      optimism: "Optimism",
      emotional_regulation: "Emotional Regulation",
      ownership: "Ownership & Initiative",
      flexibility: "Flexibility",
      social_support: "Social Support",
      purpose: "Purpose & Mission",
      grit: "Grit & Perseverance",
    }[key] || key
  );
}

export function dimensionShort(key) {
  return (
    {
      optimism: "OPT",
      emotional_regulation: "ER",
      ownership: "OWN",
      flexibility: "FLEX",
      social_support: "SOC",
      purpose: "PUR",
      grit: "GRIT",
    }[key] || key.toUpperCase().slice(0, 4)
  );
}
